<template>
    <section>
        <div class="fixed z-40 inset-0 overflow-y-auto">
            <div
                class="
                    flex
                    items-end
                    justify-center
                    min-h-screen
                    pt-4
                    px-4
                    pb-20
                    text-center
                    sm:block sm:p-0
                    mt-16
                "
            >
                <!-- <transition
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100"
                    leave-to-class="opacity-0"
                > -->

                <!-- <div class="fixed inset-0 transition-all opacity-0">
                    <div
                        class="absolute inset-0 bg-gray-200 opacity-50"
                        style="opacity: 0.1"
                    ></div>
                </div> -->

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span
                    class="hidden sm:inline-block sm:align-middle sm:h-screen"
                ></span
                >&#8203;
                <!-- </transition>

                <transition
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                > -->
                <div
                    v-if="show"
                    class="
                        inline-block
                        align-bottom
                        bg-white
                        rounded-lg
                        px-4
                        pt-5
                        pb-4
                        text-left
                        overflow-hidden
                        shadow-2xl
                        transform
                        transition-all
                        sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6
                    "
                    role="dialog"
                    style="
                        box-shadow: 0px 0px 1000px 1000px rgba(0, 0, 0, 0.5) !important;
                    "
                    aria-modal="true"
                    aria-labelledby="modal-headline"
                >
                    <div>
                        <div
                            class="
                                mx-auto
                                flex
                                items-center
                                justify-center
                                h-12
                                w-12
                                rounded-full
                                bg-orange-100
                            "
                        >
                            <svg
                                class="w-6 h-6 text-orange-600"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                                />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="
                                    text-lg
                                    leading-6
                                    font-medium
                                    text-gray-900
                                "
                            >
                                {{ poll.question }}
                            </h3>
                            <div class="mt-2 hidden">
                                <p class="text-sm leading-5 text-gray-500"></p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-6">
                        <span
                            class="flex w-full rounded-md shadow-sm mb-2"
                            v-for="(answer, index) in poll.answers"
                            :key="index"
                        >
                            <a
                                @click="answerPoll(poll, answer)"
                                class="
                                    cursor-pointer
                                    outline-none
                                    inline-flex
                                    justify-center
                                    w-full
                                    rounded-md
                                    border border-transparent
                                    px-4
                                    py-2
                                    bg-blue-800
                                    text-base
                                    leading-6
                                    font-medium
                                    text-blue-50
                                    shadow-sm
                                    hover:bg-blue-900
                                    unused-focus:outline-none
                                    transition
                                    ease-in-out
                                    duration-150
                                    sm:text-sm sm:leading-5
                                    tts-button
                                "
                                >{{ answer }}</a
                            >
                        </span>
                    </div>
                </div>
                <!-- </transition> -->
            </div>
        </div>
    </section>
</template>
<script>
import Swal from "sweetalert2";
export default {
    mounted() {
        console.log("Poll mounted.");

        let self = this;
        setTimeout(function () {
            self.show = true;
        }, 3);
    },
    created() {
        //
    },
    props: ["talk_id", "poll"],
    data() {
        return {
            show: false,
        };
    },
    methods: {
        hideModal() {
            let self = this;
            this.show = false;
            setTimeout(function () {
                self.$emit("hide");
            }, 1200);
        },
        answerPoll(poll, answer) {
            let self = this;
            Swal.fire({
                title: self.t("tts.polls.answer-submit-title"),
                // text: self.t("tts.polls.answer-confirm", { answer: answer }),
                text: self.t(
                    "tts.polls.answer-confirm",
                    'Weet je zeker dat je wil stemmen op: ":value"?',
                    answer
                ),

                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    if (true) {
                        axios
                            .put("/api/polls/" + poll.id, {
                                answer: answer,
                            })
                            .then((response) => {
                                Eventing.fire("pollVoted", {
                                    pollId: poll.id,
                                    answer: answer,
                                });
                                self.hideModal();
                            })
                            .catch((error) => {
                                if (error.response) {
                                    if (error.response.status == 409) {
                                        Swal.fire(
                                            self.t(
                                                "tts.polls.answer-submit-error"
                                            ),
                                            self.t("tts.polls.error-closed"),
                                            "error"
                                        );
                                        self.hideModal();
                                    }
                                    if (error.response.status == 403) {
                                        Swal.fire(
                                            self.t(
                                                "tts.polls.answer-submit-error"
                                            ),
                                            self.t("tts.polls.error-403"),
                                            "error"
                                        );
                                        self.hideModal();
                                    }
                                    // alert("Error: " + error.response.status);
                                }
                            });
                    }
                }
            });
        },
    },
};
</script>
